module.exports = __webpack_public_path__ + "static/media/MirateAlEspejoPortada.d4b8d2ec.png";